import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InvoiceCompanyClient, InvoicePatient } from '../../../models/invoices';

@Component({
  selector: 'app-invoices-company-clients',
  standalone: true,
  imports: [
    SharedModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './invoices-company-clients.component.html',
  styleUrl: './invoices-company-clients.component.scss',
})
export class InvoicesCompanyClientsComponent {
  @Input() companyClients: InvoiceCompanyClient[] = [];
  @Input() patients: InvoicePatient[] = [];
  @Input() isLoading: boolean = false;
  @Output() togglePanel = new EventEmitter<InvoiceCompanyClient>();
  @Output() deleteRequest = new EventEmitter<InvoiceCompanyClient>();

  displayedColumns: string[] = [
    'ragioneSociale',
    'partitaIva',
    'paziente',
    'actions',
  ];

  deleteClient(client: InvoiceCompanyClient) {
    this.deleteRequest.emit(client);
  }
  modifyClient(client: InvoiceCompanyClient) {
    this.togglePanel.emit(client);
  }
}
